module.exports = __webpack_public_path__ + "img/3.fdaee140.jpg";